<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import moment from 'moment'
import { commissionService } from "../../../../services/reportservice/commission.service.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Expense Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Select, 
    Input
  },
  data() {
    return {
      title: "Expense Report",
      
      data: [],
      projects: [],
      seller_types: [],
      summary: [],
      commissions: [],
      statuses: [],
      principal_paid_types: [
        {id:1 , label:'ចាប់ពី ២.៥%'},
        {id:2 , label:'ចាប់ពី ៥%'},
        {id:3 , label:'ចាប់ពី ១០%'},
        {id:4 , label:'ចាប់ពី ១៥%'},
        {id:5 , label:'ចាប់ពី ២០%'}
      ],
      principal_paid_type: 0,

      project_id: 1,
      seller_type_id: 1,
      status_id: 0,

      seller_summary: [],
      seller_sumary_index: 1,
      seller_sumary_commission: 0,
      seller_commission_2p : 0,

      sale_start_date: '',
      sale_end_date: '',
      pay_start_date:  this.$moment().clone().startOf('month').format('YYYY-MM-DD'),
      pay_end_date: this.$moment().clone().endOf('month').format('YYYY-MM-DD'),
      
      project_name: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      user: JSON.parse(localStorage.getItem('user')),

      staft_index: 0,
      
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    console.log(this.pay_start_date);
    var objRequest = {
      seller_type_id:   this.seller_type_id,
      pay_start_date:   this.pay_start_date,
      pay_end_date:     this.pay_end_date
    };
    this.loadingData(objRequest);
    
  },
  methods: {
    
    loadingData: function(objRequest) {
      this.fetchingStats = false;
     
      commissionService.getCommission(objRequest)
        .then(response => {
            this.fetchingStats = true;

            this.data = response.data;
            this.commissions = response.data.list;
            this.summary = response.data.summary;
            this.seller_summary = response.data.seller_summary;
            this.seller_commission_2p = response.data.seller_commission_2p;
            
            this.seller_sumary_index = 1;
            this.seller_sumary_commission = 0;

            this.countUnitByStaft();

            this.projects = response.data.projects;
            this.statuses = response.data.statuses;
            this.seller_types = response.data.seller_types;
            
            this.project_name = response.data.project_name;
        });
    },
   
    submitSearch: function() {


      var objRequest = {
        project_id:       this.project_id,
        seller_type_id:   this.seller_type_id,
        fn_summit: 1,
        sale_start_date:  this.sale_start_date,
        sale_end_date:    this.sale_end_date,
        pay_start_date:   this.pay_start_date,
        pay_end_date:     this.pay_end_date,
        status_id:        this.status_id,
        principal_paid_type:  this.principal_paid_type,
      };
      commissionService.getCommission(objRequest)
        .then(response => {
            this.fetchingStats = true;

            this.data = response.data;
            // console.log(response.data);
            this.commissions = response.data.list;
            this.seller_summary = response.data.seller_summary;
            this.seller_commission_2p = response.data.seller_commission_2p;
            this.seller_sumary_index = 1;
            this.seller_sumary_commission = 0;

            this.summary = response.data.summary;
            this.pay_start_date = response.data.pay_start_date;
            this.pay_end_date = response.data.pay_end_date;
            this.project_name = response.data.project_name;

            this.countUnitByStaft();
            console.log(JSON.stringify(this.data.thoeun));
        });
       // alert('it work 2');
    },

    countUnitByStaft() {

      let arrs = [];
      this.seller_summary.map((item) => {
        arrs.push({
          name: item.name,
          count: this.commissions.filter( el => el.seller_name == item.name).length,
          commission: item.commission,
        });
      });

      this.seller_summary = arrs;
    },

    dateFormat: function(value){
     
      if(value != null)
        return moment(String(value)).format('DD/MM/YYYY');
      else
        return '';
    },
    formatCurrency(value) {
      if(value == 0 ){
        return 0;
      }
      let sign = '$';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    numberFormat(value) {
      if(!value){
        return '';
      }
      let sign = '';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },
    total(column) {
      return this.commissions.reduce(function (sum, item) {
        return sum + item[column];
      }, 0)
    },
    totalSummary(column) {
      return this.projectExpense.reduce(function (sum, item) {
        return sum + item[column];
      }, 0)
    },
    sum_commission(commission) {
      this.seller_sumary_index += 1;
      this.seller_sumary_commission += commission;
      return commission;
    },

    incrementCounter: function () {
      this.staft_index = this.staft_index + 1;
      return this.staft_index;
    },
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.text')+$t('report.income_expense.daily_expense')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              <div class="col-sm-3">
                <label>{{$t('project.text')}}</label>
                <Select
                    :id="'id'"
                    :text="'name'"
                    :editable="true"
                    :list="{data: this.projects}"
                    v-model="project_id"
                    /> 
              </div>
              <div class="col-sm-3">
                  <label>{{$t('general.sale_date')}}</label>
                  <Input 
                  :type="'date'"
                  :date="false"
                  :id="'sale_start_date'"
                  v-model="sale_start_date"
                  /> 
              </div>
              <div class="col-sm-3">
                  <label>{{$t('general.to_date')}}</label>
                  <Input 
                  :type="'date'"
                  :date="false"
                  :id="'sale_end_date'"
                  v-model="sale_end_date"
                  /> 
              </div>
              <div class="col-sm-3">
                <label>{{$t('general.principal_paid')}}</label>
                <Select
                    :editable="true"
                    :list="{data: this.principal_paid_types}"
                    v-model="principal_paid_type"
                    /> 
              </div>
          </div>
          <div class="row search-area">
              <div class="col-sm-3">
                <label>{{$t('general.status')}}</label>
                <Select
                    :id="'id'"
                    :text="'name'"
                    :editable="true"
                    :list="{data: this.statuses}"
                    v-model="status_id"
                    /> 
              </div>
              <div class="col-sm-3">
                  <label>{{$t('general.pay_date')}}</label>
                  <Input 
                  :type="'date'"
                  :date="false"
                  :id="'pay_start_date'"
                  v-model="pay_start_date"
                  /> 
              </div>
              <div class="col-sm-3">
                  <label>{{$t('general.to_date')}}</label>
                  <Input 
                  :type="'date'"
                  :date="false"
                  :id="'pay_end_date'"
                  v-model="pay_end_date"
                  /> 
              </div>
              <div class="col-sm-3">
                <label class="text-white">{{$t('report.text')}}</label>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>

          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="35%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td style="text-align:center;">
                    <h4 class="khb"><u>{{$t('commission.report_staff')}}</u></h4>
                    <h4 class="khb"><u>គម្រោង: {{project_name}}</u></h4>
                    <h4 class="khb"><u>កាលរិច្ឆេទ: {{this.dateFormat(pay_start_date)}} - {{this.dateFormat(pay_end_date)}}</u></h4>
                </td>
              </tr>
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th rowspan="2">{{$t('general.number')}}</th>
                  <th rowspan="2">{{$t('general.sale_date')}}</th>
                  <th rowspan="2">{{$t('general.property')}}</th>
                  <th rowspan="2" style="width:7em">{{$t('general.customer')}}</th>
                  <th rowspan="2" style="width:7em">{{$t('general.seller')}}</th>
                  <th rowspan="2">{{$t('general.principal_price')}}</th>
                  <th rowspan="2">{{$t('general.discount')}}</th>
                  <th rowspan="2">{{$t('general.sale_price')}}</th>

                  <th colspan="2">{{$t('customer.paid_amount')}}</th>
                  <th colspan="4">{{$t('general.commission_staff')}}</th>

                  <th rowspan="2" style="width:8em">{{$t('commission.date_to_pay')}}</th>
                  <th rowspan="2">{{$t('general.status')}}</th>
                </tr>
                <tr class="thead">
                  <th>{{$t('general.amount')}}</th>
                  <th>{{$t('general.percentage')}}</th>

                  <th>0.30%</th>
                  <th>0.20%</th>
                  <th>{{$t('general.total')}}</th>
                  <th>{{$t('general.paid')}}</th>
                </tr>
              
                <tbody>
                    <tr v-for="(list, no) in commissions" :key="list.id" >

                        <td>{{no + 1}}</td>
                        <td>{{dateFormat(list.sale_date)}}</td>
                        <td :title="list.id">{{list.property}}</td>
                        <td>{{list.customer}}</td>
                        <td>{{list.seller_name}}</td>
                        <td>{{formatCurrency(list.price)}}</td>
                        <td>{{formatCurrency(list.discount)}}</td>
                        <td>{{formatCurrency(list.sale_price)}}</td>

                        <td>{{formatCurrency(list.paid)}}</td>
                        <td>{{list.paid_percentage}}</td>

                        <td>{{formatCurrency(list.commission_fee * 0.6)}}</td>
                        <td>{{formatCurrency(list.commission_fee * 0.4)}}</td>
                        <td>{{formatCurrency(list.commission_fee)}}</td>
                        <td>{{formatCurrency(list.commission_paid)}}</td>
                        
                        <td>{{dateFormat(list.date_to_pay)}}</td>
                        <td>{{list.commission_status}}</td>
                    </tr>
                </tbody>
                
                    <tr class="tfoot" v-if="data">
                        <td colspan="5" class="text-end pe-2">{{$t('report.total')}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('price'))}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('discount'))}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('sale_price'))}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('paid'))}}</td>
                        <td></td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(commissions.reduce((sum, item) => sum+(item.commission_fee * 0.6), 0))}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(commissions.reduce((sum, item) => sum+(item.commission_fee * 0.4), 0))}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('commission_fee'))}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('commission_paid'))}}</td>
                        <td><p></p></td>
                        <td><p></p></td>
                    </tr>
            </table>
            <br>
            <div class="row">
              <div class="col-sm-6">
                <table  class="content-general h8 project-sumary-table report-table" width="100%">
                 
                    <tr class="thead">
                      <th>{{$t('general.number')}}</th>
                      <th>{{$t('general.seller')}}</th>
                      <th>{{$t('general.toal-unit')}}</th>
                      <th>{{$t('general.commission')}}</th>
                    </tr>
                 
                  <tbody>
                    <tr v-for="(ss, index) in seller_summary" :key="ss.id">
                      <td>{{index + 1}}</td>
                      <td>{{ss && ss.name}}</td>
                      <td>{{ss && ss.count}}</td>
                      <td>{{ss && formatCurrency(ss.commission)}}</td>
                    </tr>
                    <tr>
                      <td>{{seller_summary.length + 2}}</td>
                      <td colspan="2">កម្រៃជើងសាររួម</td>
                      <td>{{formatCurrency(seller_commission_2p)}}</td>
                    </tr>
                  </tbody>
                    <tr class="tfoot">
                      <td colspan="2">{{$t('general.total')}}</td>
                      <td></td>
                      <td>{{formatCurrency(seller_summary.reduce((sum, item) => sum+(item.commission), 0) + seller_commission_2p)}}</td>
                    </tr>
                </table>
              </div>
            </div>
            <br>
       
            <div class="row mt-3 report-table">
              <div class="col">
                <center>
                  <p class="mt-4">អនុម័តដោយ<br>នាយកផ្នែកទីផ្សារ</p>
                  <p class="mt-5">លី ប៊ុនហ៊ាង</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">ត្រួតពិនិត្យដោយ<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <p class="mt-5">..........................</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">ត្រួតពិនិត្យដោយ<br>ប្រធានគណនេយ្យ</p>
                  <p class="mt-5">............................</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>

              <div class="col">
                <center>
                  <p class="mt-4">កត់ត្រាដោយ<br>គណនេយ្យករ</p>
                   <p class="mt-5">{{this.user.name}}</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
             
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>